module.exports = __webpack_public_path__ + "static/media/Photoshop.35b7358e.svg";